var _circle, _g, _circle2, _g2, _circle3, _circle4, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.9,
    fill: "white",
    fillOpacity: 0.07,
    stroke: "url(#paint0_radial_0_183)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_183)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "url(#paint1_radial_0_183)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.75,
    stroke: "url(#paint2_linear_0_183)",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 69,
    height: 68
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9995,
    cy: 37.0001,
    r: 33.9,
    fill: "url(#paint3_linear_0_183)",
    stroke: "url(#paint4_radial_0_183)",
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_183)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.4995,
    cy: 37.5001,
    r: 21.5,
    fill: "url(#paint5_linear_0_183)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4995,
    cy: 37.5001,
    r: 21.4,
    stroke: "url(#paint6_radial_0_183)",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 46,
    height: 46
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2137,
    cy: 27.6429,
    r: 22.5,
    fill: "url(#paint7_linear_0_183)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2137,
    cy: 27.6429,
    r: 22.4,
    stroke: "url(#paint8_radial_0_183)",
    strokeOpacity: 0.76,
    strokeWidth: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_183)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.9995,
    cy: 30.8572,
    r: 11.5714,
    fill: "url(#paint9_linear_0_183)",
    fillOpacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9995,
    cy: 30.8572,
    r: 11.4714,
    stroke: "url(#paint10_radial_0_183)",
    strokeWidth: 0.2
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5827 56.1666C51.3904 56.1664 51.203 56.1058 51.047 55.9933C50.8911 55.8808 50.7745 55.722 50.7137 55.5396L49.1325 50.7958C49.0766 50.6312 49.0688 50.454 49.1099 50.285C49.1509 50.1161 49.2392 49.9623 49.3644 49.8416C49.5275 49.6848 49.6889 49.5235 49.8456 49.3603C49.9659 49.236 50.1189 49.1483 50.287 49.1072C50.455 49.0662 50.6312 49.0735 50.7953 49.1284L55.539 50.7097C55.77 50.7865 55.961 50.9519 56.07 51.1696C56.179 51.3872 56.197 51.6392 56.1202 51.8702C56.0434 52.1011 55.878 52.2921 55.6603 52.4011C55.4427 52.5101 55.1907 52.5282 54.9597 52.4513L51.2014 51.1992L52.4535 54.9575C52.5 55.0955 52.5129 55.2427 52.4912 55.3867C52.4694 55.5307 52.4137 55.6675 52.3286 55.7857C52.2435 55.9038 52.1314 56 52.0017 56.0663C51.872 56.1325 51.7284 56.1669 51.5827 56.1666Z",
    fill: "url(#paint11_linear_0_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4166 56.1667C20.2714 56.1666 20.1283 56.132 19.9991 56.0658C19.8699 55.9995 19.7583 55.9036 19.6735 55.7858C19.5886 55.668 19.533 55.5318 19.5111 55.3882C19.4892 55.2447 19.5017 55.0981 19.5476 54.9603L20.7997 51.202L17.0414 52.4551C16.8104 52.5319 16.5584 52.5139 16.3408 52.4049C16.1231 52.2959 15.9577 52.1049 15.8809 51.8739C15.8041 51.643 15.8221 51.3909 15.9311 51.1733C16.0401 50.9557 16.2311 50.7903 16.4621 50.7134L21.2058 49.1313C21.3702 49.0764 21.5467 49.0693 21.7149 49.1106C21.8832 49.152 22.0362 49.2402 22.1564 49.365C22.3131 49.5273 22.4726 49.6877 22.6349 49.8444C22.7597 49.9646 22.8479 50.1177 22.8893 50.2859C22.9307 50.4541 22.9235 50.6307 22.8686 50.795L21.2856 55.5397C21.2248 55.7221 21.1082 55.8809 20.9522 55.9934C20.7963 56.1059 20.6089 56.1665 20.4166 56.1667Z",
    fill: "url(#paint12_linear_0_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9154 21.8301C22.9032 23.9688 20.6492 27.01 19.4789 30.514C18.3087 34.018 18.283 37.8033 19.4054 41.3229C20.5279 44.8424 22.7404 47.914 25.7231 50.0935C28.7059 52.273 32.3045 53.4477 35.9987 53.4477C39.6929 53.4477 43.2915 52.273 46.2743 50.0935C49.257 47.914 51.4695 44.8424 52.592 41.3229C53.7144 37.8033 53.6887 34.018 52.5185 30.514C51.3482 27.01 49.0942 23.9688 46.082 21.8301V28.6666C46.082 31.3408 45.0197 33.9056 43.1287 35.7966C41.2377 37.6876 38.673 38.7499 35.9987 38.7499C33.3244 38.7499 30.7597 37.6876 28.8687 35.7966C26.9777 33.9056 25.9154 31.3408 25.9154 28.6666V21.8301Z",
    fill: "url(#paint13_linear_0_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9987 32.3333C38.0237 32.3333 39.6654 30.6917 39.6654 28.6667C39.6654 26.6416 38.0237 25 35.9987 25C33.9737 25 32.332 26.6416 32.332 28.6667C32.332 30.6917 33.9737 32.3333 35.9987 32.3333Z",
    fill: "url(#paint14_linear_0_183)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 14.9166C33.1645 14.9138 30.3579 15.4864 27.75 16.5996V28.6666C27.75 30.8547 28.6192 32.9531 30.1664 34.5003C31.7135 36.0474 33.812 36.9166 36 36.9166C38.188 36.9166 40.2865 36.0474 41.8336 34.5003C43.3808 32.9531 44.25 30.8547 44.25 28.6666V16.5996C41.6421 15.4864 38.8355 14.9138 36 14.9166Z",
    fill: "url(#paint15_linear_0_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 15.0666L36.0001 15.0666C38.7824 15.0639 41.5366 15.6191 44.1 16.699V28.6666C44.1 30.8149 43.2466 32.8752 41.7276 34.3942C40.2085 35.9132 38.1483 36.7666 36 36.7666C33.8517 36.7666 31.7915 35.9132 30.2724 34.3942C28.7534 32.8752 27.9 30.8149 27.9 28.6666V16.699C30.4634 15.6191 33.2176 15.0639 35.9999 15.0666Z",
    stroke: "url(#paint16_linear_0_183)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9993 57.0833C47.6434 57.0833 57.0827 47.644 57.0827 36C57.0827 24.356 47.6434 14.9166 35.9993 14.9166C24.3553 14.9166 14.916 24.356 14.916 36C14.916 47.644 24.3553 57.0833 35.9993 57.0833Z",
    fill: "url(#paint17_radial_0_183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9327 36C56.9327 47.5611 47.5605 56.9333 35.9993 56.9333C24.4382 56.9333 15.066 47.5611 15.066 36C15.066 24.4388 24.4382 15.0666 35.9993 15.0666C47.5605 15.0666 56.9327 24.4388 56.9327 36Z",
    stroke: "url(#paint18_linear_0_183)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 14.9166C33.1645 14.9138 30.3579 15.4864 27.75 16.5996V28.6666C27.75 30.8547 28.6192 32.9531 30.1664 34.5003C31.7135 36.0474 33.812 36.9166 36 36.9166C38.188 36.9166 40.2865 36.0474 41.8336 34.5003C43.3808 32.9531 44.25 30.8547 44.25 28.6666V16.5996C41.6421 15.4864 38.8355 14.9138 36 14.9166Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.75 18.6337V20.6669C30.2848 19.2993 33.1198 18.5832 36 18.5832C38.8802 18.5832 41.7152 19.2993 44.25 20.6669V18.6337C41.6765 17.3939 38.8566 16.75 36 16.75C33.1434 16.75 30.3235 17.3939 27.75 18.6337Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2782 44.426C26.4501 44.2541 26.6832 44.1576 26.9262 44.1576C27.1693 44.1576 27.4024 44.2541 27.5743 44.426C29.8091 46.6606 32.84 47.9159 36.0003 47.9159C39.1606 47.9159 42.1915 46.6606 44.4263 44.426C44.5992 44.259 44.8308 44.1666 45.0711 44.1687C45.3115 44.1708 45.5414 44.2672 45.7113 44.4371C45.8813 44.6071 45.9777 44.837 45.9798 45.0774C45.9819 45.3177 45.8895 45.5493 45.7225 45.7221C43.1439 48.3004 39.6468 49.7489 36.0003 49.7489C32.3539 49.7489 28.8567 48.3004 26.2782 45.7221C26.1063 45.5502 26.0098 45.3171 26.0098 45.0741C26.0098 44.831 26.1063 44.5979 26.2782 44.426Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0827 17.4888V19.632C49.6535 21.8278 52.41 25.1291 53.9333 29.0345C55.4567 32.9398 55.6636 37.2356 54.5226 41.2693C53.3816 45.303 50.9552 48.8539 47.6119 51.3827C44.2686 53.9115 40.1913 55.2798 35.9994 55.2798C31.8074 55.2798 27.7301 53.9115 24.3868 51.3827C21.0435 48.8539 18.6171 45.303 17.4761 41.2693C16.3352 37.2356 16.5421 32.9398 18.0654 29.0345C19.5887 25.1291 22.3452 21.8278 25.916 19.632V17.4888C21.8006 19.73 18.5491 23.2785 16.6751 27.5736C14.8012 31.8688 14.4116 36.6659 15.568 41.2071C16.7244 45.7484 19.3607 49.775 23.0607 52.6508C26.7606 55.5267 31.3132 57.0879 35.9994 57.0879C40.6855 57.0879 45.2381 55.5267 48.9381 52.6508C52.638 49.775 55.2744 45.7484 56.4307 41.2071C57.5871 36.6659 57.1975 31.8688 55.3236 27.5736C53.4497 23.2785 50.1982 19.73 46.0827 17.4888Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_0_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9987 32.3333C38.0237 32.3333 39.6654 30.6917 39.6654 28.6667C39.6654 26.6416 38.0237 25 35.9987 25C33.9737 25 32.332 26.6416 32.332 28.6667C32.332 30.6917 33.9737 32.3333 35.9987 32.3333Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_183",
    x: -50,
    y: -50,
    width: 172,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_183",
    x: 0.19945,
    y: 2.20006,
    width: 70.6,
    height: 70.5999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.9,
    result: "effect1_foregroundBlur_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_183",
    x: 9.92804,
    y: 4.78577,
    width: 52.1429,
    height: 52.1428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.25,
    result: "effect1_foregroundBlur_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_0_183",
    x: 21.75,
    y: 8.91663,
    width: 28.5,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_183",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_0_183",
    x: 8.91602,
    y: 8.91663,
    width: 54.1667,
    height: 54.1666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_183",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_0_183",
    x: 27.75,
    y: 14.9166,
    width: 16.5,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_0_183",
    x: 27.75,
    y: 16.75,
    width: 16.5,
    height: 5.91687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_0_183",
    x: 26.0098,
    y: 44.1576,
    width: 19.97,
    height: 7.59131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_0_183",
    x: 14.916,
    y: 17.4888,
    width: 42.1667,
    height: 41.5991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_0_183",
    x: 32.332,
    y: 25,
    width: 7.33331,
    height: 9.33331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_183"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.647622 2.14215) rotate(44.0741) scale(97.7779 156.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.647622 2.14215) rotate(44.0741) scale(97.7779 156.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E7FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5777,
    stopColor: "#F7FBFF",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_183",
    x1: 64,
    y1: 24.5,
    x2: 7.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575D9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_183",
    x1: 2.99945,
    y1: 37.0001,
    x2: 70.9995,
    y2: 37.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.61109 5.0232) rotate(44.0741) scale(92.3458 147.694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_183",
    x1: 13.9995,
    y1: 37.5001,
    x2: 56.9995,
    y2: 37.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3862 17.2794) rotate(44.0741) scale(58.3952 93.3947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_183",
    x1: 7.71375,
    y1: 27.6429,
    x2: 52.7137,
    y2: 27.6429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.11851 6.48172) rotate(44.0741) scale(61.1112 97.7386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_183",
    x1: 24.428,
    y1: 30.8572,
    x2: 47.5709,
    y2: 30.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56B4D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6362 19.9743) rotate(44.0741) scale(31.4286 50.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_183",
    x1: 49.0839,
    y1: 49.0811,
    x2: 57.4281,
    y2: 51.1991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_183",
    x1: 15.834,
    y1: 49.0841,
    x2: 24.1763,
    y2: 51.2021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_183",
    x1: 18.582,
    y1: 21.8301,
    x2: 59.0902,
    y2: 33.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_183",
    x1: 32.332,
    y1: 25,
    x2: 40.9705,
    y2: 27.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_183",
    x1: 27.75,
    y1: 14.9166,
    x2: 47.7156,
    y2: 18.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_183",
    x1: 28.2656,
    y1: 15.9166,
    x2: 44.25,
    y2: 15.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_0_183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2077 12.2812) rotate(83.1199) scale(45.398 83.0733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9870E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465667,
    stopColor: "#4C25B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32175B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_183",
    x1: 16.2337,
    y1: 16.8333,
    x2: 57.0827,
    y2: 16.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline3);
export default __webpack_public_path__ + "static/media/IconTimeline3.0ba837d479ad430765815e0687791903.svg";
export { ForwardRef as ReactComponent };